import React from 'react';
import { CanvasContent } from '../types/cockpit';
import GlobalCanvas from './GlobalCanvas';
import { useGlobalCanvas } from '../contexts/GlobalCanvasContext';

// Interface for AICanvas props
interface AICanvasProps {
  content: CanvasContent | null;
  onLeftSidebarToggle: () => void;
  onRightSidebarToggle: () => void;
  connectionStatus: 'connected' | 'disconnected' | 'checking';
  onTaskUpdate?: () => void;
  onEmailUpdate?: () => void;
}

// Main AICanvas component - now powered by GlobalCanvas
const AICanvas: React.FC<AICanvasProps> = ({
  content,
  onLeftSidebarToggle,
  onRightSidebarToggle,
  connectionStatus,
  onTaskUpdate,
  onEmailUpdate
}) => {
  const { openContent } = useGlobalCanvas();

  // Handle legacy content - automatically open in canvas when content changes
          React.useEffect(() => {
    if (content && content.title) {
      openContent(content);
    }
  }, [content, openContent]);

  console.log('🎯 AICanvas rendering');

  return (
    <main className="ai-canvas">
      <div className="canvas-content">
        <GlobalCanvas
          onTaskUpdate={onTaskUpdate}
          onEmailUpdate={onEmailUpdate}
        />
      </div>
    </main>
  );
};

export default AICanvas;
